import React, { forwardRef } from 'react'
import SubHeader from '../../../../../../component/common/layout/SubHeader';
import Svg from '../../../../../../component/common/Svg';
import Button from "../../../../../../core/Button";
import style from "../../../../../style.module.css";
import { EditText, EditTextarea } from 'react-edit-text';

import Axios from "axios";
import Card from "../../../../../../core/Card";
import EditorMultipleChoice from "../../../../../../component/common/EditorMultipleChoice";

import 'react-edit-text/dist/index.css';
import { useState, useEffect } from 'react';
// import Opinion from './Opinion';

import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { addQuestion, addSection, getSurveyData, getSurveyQuestionData, getSurveySectionData, orderSection, saveSurveyDes, saveSurveyTitle } from '../../../../../../store/actions/qnaBuilderAction';
import { useVerifySurveyId } from '../../../../../../hooks';
import SectionHeader from './components/SectionHeader';
import SectionContent from './components/SectionContent';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const CustomComponent = forwardRef < HTMLDivElement > ((props, ref) => {
  return <div ref={ref}>{props.children}</div>;
});

const language_code = '22';

export default function IndexBackup() {
  const { t, i18n } = useTranslation();

  const [survey_title, setSurveyTitle] = useState('')
  const [survey_format, setSurveyFromat] = useState('')
  const [survey_format_text, setSurveyFromatText] = useState('')
  const [survey_setting, setSurveySetting] = useState([])

  const [landingchecked, setLandingChecked] = useState(false)
  const landingHandleClick = () => setLandingChecked(!landingchecked)

  const [thankyouchecked, setThankyouChecked] = useState(false)
  const thankyouHandleClick = () => setThankyouChecked(!thankyouchecked)

  const [leadGenchecked, setLeadGenChecked] = useState(false)
  const leadGenHandleClick = () => setLeadGenChecked(!leadGenchecked)

  const [sectionchecked, setSectionChecked] = useState(false)
  const sectionHandleClick = () => setSectionChecked(!sectionchecked)

  const [scoringchecked, setScoringChecked] = useState(false)
  const scoringHandleClick = () => setScoringChecked(!scoringchecked)


  //section/Question array state Variables
  const [sectionFetched, setSectionFetched] = useState([]);
  const [questionFetched, setQuestionFetched] = useState([]);


  //Mcq
  const [mcqQuestionTitle, setMcqQuestionTitle] = useState('This is title');
  //Counter
  const [mcqQuestionChoice, setMcqQuestionChoice] = useState(0);

  //new qustion Fields 
  const [mcqQuestionChoiceText, setMcqQuestionChoiceText] = useState('');
  const [mcqQuestionChoiceScore, setMcqQuestionChoiceScore] = useState('');

  //update existing choice & score
  const [mcqUpdateChoice, setMcqUpdateChoice] = useState('');
  const [mcqUpdateScore, setMcqUpdateScore] = useState('');

  //fetched mcq fields
  const [mcqFetchedText, setMcqFetchedText] = useState([]);
  const [mcqFetchedScore, setMcqFetchedScore] = useState([]);
  const [mcqFetchedData, setMcqFetchedData] = useState([1], [1]);
  const [mcqQuestionOrderNo, setMcqQuestionOrderNo] = useState('');

  const [mcqIsScore, setMcqIsScore] = useState(true);
  const mcqIsScoreChecked = () => setMcqIsScore(!mcqIsScore)

  //Input Text
  const [inputQueText, setInputQueText] = useState('Your Question here..');

  const [focusedClass, setFocusedClass] = useState('');
  const [focusedRef, setFocusedRef] = useState('');


  //Default language code (TODO change) DUMMY DATA 
  const language_code = '22';
  const section_id = 'abc';
  const question_id = '1';

  const [setOpen] = useState(false);
  const [styling, setstyling] = useState({
    status: false,
    from: "",
    style: ""
  });



  /**
   * STATES
   */


  //==> States <==
  const [modalSortableSurveySectionData, setmodalSortableSurveySectionData] = useState(null)
  const [sectionWiseQuestion, setSectionWiseQuestion] = useState(null)
  const [surveyHeaderEditMode, setSurveyHeaderEditMode] = useState(false)

  //Selector
  const { surveyDetails: surveyData, surveySectionData, surveyQuestionData } = useSelector((state) => state.qnaData)
  const { survey_name } = useSelector((state) => state.permissionsData)

  //Others
  const survey_id = useVerifySurveyId()
  const dispatch = useDispatch()


  //==> FORM SCHEMA AND VALIDATION <==

  //Yup
  const formSchema = Yup.object().shape({
    surveyTitle: Yup.string().trim().required('Survey name required'),
    surveyDesc: Yup.string().trim().required(t('survey.surveyRequire'))
  })

  //Formik
  const initialValues = {
    surveyTitle: '',
    surveyDesc: '',
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: formSchema,
  })

  const {
    values,
    handleChange,
    touched,
    errors,
    setFieldValue,
    setFieldTouched,
  } = formik


  //==> FUNCTIONALITIES <==

  //Save survey title and description 
  const handleSaveTitle = async ({ name, value, previousValue }) => {
    if (value) {
      const payload = {
        val: value,
        survey_id: survey_id,
        language_code: language_code,
      }
      dispatch(saveSurveyTitle(payload))
    }
  }

  const handleSaveDescription = ({ name, value, previousValue }) => {
    if (value) {
      const payload = {
        val: value,
        survey_id: survey_id,
        language_code: language_code,
      }
      dispatch(saveSurveyDes(payload))
    }
  }

  //Fetch survey daya
  const fetchSurveyData = async (survey_id) => {
    dispatch(getSurveyData(survey_id))
  }

  const fetchedSection = async (survey_id) => {
    dispatch(getSurveySectionData(survey_id))
  }

  const fetchQuestion = async (survey_id) => {
    dispatch(getSurveyQuestionData(survey_id))
  }

  //Section sorting handling
  const fetchPayloadForUpdateOrderingApi = (sections) => {
    const payload = {}
    sections?.forEach((section, index) => {
      payload[section.su_section_id] = index + 1
    })
    return payload
  }

  const saveNewSortedSection = (sections) => {
    const payload = { section_order: fetchPayloadForUpdateOrderingApi(sections) }
    dispatch(orderSection(payload))
  }

  const resetModalSectionData = () => {
    setmodalSortableSurveySectionData(surveySectionData)
  }

  //Section handling
  const handleAddSection = (index) => {
    const payload = {
      language_code: language_code,
      su_survey_id: survey_id,
      section_text: ""
    }
    dispatch(addSection(payload))
  }

  //Question handling
  const handleAddQuestion = (sectionID) => {
    const payload = {
      language_code: language_code,
      section_id: sectionID,
      survey_id: survey_id,
      question_text: ""
    }
    dispatch(addQuestion(payload))
  }

  //React-beautiful-dnd
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  }

  const onDragEnd = (result) => {
    if (window.modulePermissions.M11.edit != 1) {
      return;
    }
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    const sections = reorder(
      modalSortableSurveySectionData,
      result.source.index,
      result.destination.index
    )
    setmodalSortableSurveySectionData(sections)
  }


  //==> EFFECTS <==

  useEffect(() => {
    if (survey_id) {
      fetchSurveyData(survey_id);
      fetchedSection(survey_id);
      fetchQuestion(survey_id);
      fetchQuestionMcq(survey_id);
    }
  }, [survey_id]);

  useEffect(() => {
    if (surveyData?.length > 0) {
      const surveyDetails = surveyData[0]
      // console.log('surveyData', surveyDetails)

      let suTitle = surveyDetails.su_survey_title && JSON.parse(surveyDetails.su_survey_title)[language_code]
      let suDescription = surveyDetails.su_description && JSON.parse(surveyDetails.su_description)['col_language']

      setFieldValue('surveyTitle', suTitle)
      setFieldValue('surveyDesc', suDescription)

      setLandingChecked((surveyDetails.su_is_landing_page === 1) ? true : false);
      setThankyouChecked((surveyDetails.su_is_thankyou_page === 1) ? true : false);
      setLeadGenChecked((surveyDetails.su_is_lead_gen_form === 1) ? true : false);
      setScoringChecked((surveyDetails.su_is_score === 1) ? true : false);
      setSectionChecked((surveyDetails.su_is_sections === 1) ? true : false);
      setSurveyFromat(surveyDetails.su_survey_format_id);
      setSurveySetting((surveyDetails.su_settings && JSON.parse(surveyDetails.su_settings) != null ? (JSON.parse(surveyDetails.su_settings) ?? {}) : 0));
    }
  }, [surveyData])

  useEffect(() => {
    if (surveyQuestionData) {
      const tmpData = {}
      surveyQuestionData.forEach((question) => {
        if (!tmpData[question.su_section_id]) {
          tmpData[question.su_section_id] = []
        }
        tmpData[question.su_section_id].push(question)
      })
      setSectionWiseQuestion(tmpData)
    }
  }, [surveyQuestionData])

  useEffect(() => {
    if (surveySectionData) {
      setmodalSortableSurveySectionData(surveySectionData)
    }
  }, [surveySectionData])


  /**
   *   END
   */


  const inputQueTextInsert = (value) => {
    //  alert(value);
    setInputQueText(value);
  }

  const sectionFocused = (value) => {
    //  alert(value);
    setFocusedRef(value);
    setFocusedClass('accordion-item pb-0 pt-0');
  }

  const filteredArr = (sectionFetched) => {
    const arr = questionFetched.filter((value) => value.su_section_id == sectionFetched.su_section_id);
    return arr;

  }

  const childToParent = (value) => {

    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updQuesText", {
      //TODO dynamic Id
      question_id: question_id,
      question_text: value,
      language_code: language_code

    }).then((response) => {

      console.log(response);
      if (response.status == 200) {

        fetchQuestionMcq(section_id);

      } else {
        alert("Try Again, Error");
      }
    });
  }

  function clearNewSectionStatus() {
    //clear counter and values for new section
    setMcqQuestionChoice(0);
    setMcqQuestionChoiceText('');
    setMcqQuestionChoiceScore('');
  }

  const addNewChoiceMcq = () => {
    if (mcqQuestionChoice < 1) {
      setMcqQuestionChoice(mcqQuestionChoice + 1);
    }
    else {
      alert("Field can't be Empty");
    }
  }

  const insertMcqText = (optionKey) => {
    // alert(mcqQuestionChoiceText);
    // alert(optionKey);
    if (mcqQuestionChoiceText != '' && mcqIsScore == false) {
      mcqTextInsert();
    }

  }

  function mcqTextInsert() {
    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/newQueChoiceText", {
      language_code: language_code,
      //TODO fetched and change
      question_id: question_id,
      key: (Object.keys(mcqFetchedText).length) + 1,
      value: mcqQuestionChoiceText,

    }).then((response) => {

      if (response.status == 200) {
        // alert("successfull!");
        clearNewSectionStatus();
        fetchQuestionMcq();

      } else {
        alert("Try Again, Error");
      }
    });
  }

  const insertMcqScore = (optionKey) => {
    // alert(mcqQuestionChoiceScore);
    // alert(optionKey);
    if (mcqQuestionChoiceScore != '' && mcqQuestionChoiceText != '') {
      //Inserting text first
      mcqTextInsert();
      Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/newQueChoiceScore", {
        //TODO fetched and change
        question_id: question_id,
        key: (Object.keys(mcqFetchedScore).length) + 1,
        value: mcqQuestionChoiceScore,

      }).then((response) => {

        if (response.status == 200) {
          // alert("successfull!");
          clearNewSectionStatus();
          fetchQuestionMcq();
        } else {
          alert("Try Again, Error");
        }
      });
    }

  }

  const updateMcqText = (key, value) => {
    // alert(mcqFetchedText.length);

    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updQueChoiceText", {
      language_code: language_code,
      //TODO fetched and change
      question_id: question_id,
      key: key,
      value: mcqUpdateChoice,

    }).then((response) => {

      if (response.status == 200) {
        // alert("successfull!");
        setMcqFetchedText('');
        fetchQuestionMcq();
      } else {
        alert("Try Again, Error");
      }
    });
  }

  const updateMcqScore = (key, value) => {
    // alert(mcqQuestionChoiceScore);
    // alert(mcqUpdateScore);
    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updQueChoiceScore", {
      //TODO fetched and change
      question_id: question_id,
      key: key,
      value: mcqUpdateScore,

    }).then((response) => {

      if (response.status == 200) {
        // alert("successfull!");
        setMcqFetchedScore('');
        fetchQuestionMcq();
      } else {
        alert("Try Again, Error");
      }
    });
  }

  const addNewQuestion = (id) => {

    // setquestionCounter(questionCounter + 1);
    // console.log(mcqFetchedData);
    // console.log(questionFetched);
    // alert(section_id);

    //  setMcqFetchedData([sectionFetched.map(sectionFetched => sectionFetched), questionFetched.map(questionFetched => questionFetched)]);
    //  setMcqFetchedData([...sectionFetched, ...questionFetched]);
    // console.log(mcqFetchedData);
    // setquestionCounter(questionCounter + 1);

    // let produce = [[...sectionFetched], [...questionFetched]];
    // console.log(produce);

    Axios.post(process.env.REACT_APP_NODE_API_URL + "/survey/addQues", {
      section_id: id,
      survey_id: survey_id,

    }).then((response) => {

      if (response.status == 200) {
        // alert("successfull!");
        // setquestionCounter(0);
        fetchQuestion(survey_id);
      } else {
        alert("Try Again, Error");
      }
    });

  }

  // for adding New Section
  const addNewSection = () => {
    Axios.post(process.env.REACT_APP_NODE_API_URL + "/survey/crtSection", {
      su_survey_id: survey_id,
      language_code: language_code,
    }).then((response) => {
      console.log(response)
      if (response.status == 200) {
        alert("successfull!");
        // setsectionCounter(0);
        fetchedSection(survey_id);
      } else {
        alert("Try Again, Error");
      }
    });
  }

  // function handleNewSectionTitle(e) {
  //   // alert(newSectionTitle);

  //   //TODO retive newly created section and change su_section_insted of survey ID)
  //   Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/insSectionTitle", {
  //     su_section_name: newSectionTitle,
  //     su_survey_id: survey_id,
  //     language_code: language_code,

  //   }).then((response) => {

  //     if (response.status == 200) {
  //       // alert("successfull!");
  //     } else {
  //       alert("Try Again, Error");
  //     }
  //   });
  // }



  //for updating format_type
  function handleInput(e) {
    setSurveyFromatText(e.target.getAttribute('text'));
    setSurveyFromat(e.target.value);
    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updSurveyType", {
      val: e.target.value,
      survey_id: survey_id,
      language_code: language_code,

    }).then((response) => {

      if (response.status == 200) {
        // // alert("successfull!");

      } else {
        alert("Try Again, Error");
      }
    });
  }

  //TODO DELETE (currently for demo mcq)
  const fetchQuestionMcq = async (survey_id) => {
    // Axios.get(process.env.REACT_APP_NODE_API_URL + "/survey/getQuesBySurvey?id=" + 'abc', {
    // }).then((response) => {

    //   let mcqTitle = response.data[0]?.su_question_text && JSON.parse(response.data[0]?.su_question_text);

    //   let queOptions = response.data[0]?.su_question_text && JSON.parse(response.data[0].su_options);
    //   // console.log(queOptions.common.score);
    //   if (response.status == 200) {

    //     // console.log(response.data);

    //     (setMcqQuestionTitle(mcqTitle[Object.keys(mcqTitle ?? {})[0]]));
    //     setMcqQuestionOrderNo(response.data[0].su_order_no);

    //     // setMcqFetchedText(mcqFetchedText => [...mcqFetchedText,queOptions.optionsText[language_code]]);
    //     setMcqFetchedText(queOptions.optionsText[language_code]);
    //     setMcqFetchedScore(queOptions.common.score);
    //   } else {
    //     alert("Try Again, Error");
    //   }
    // });
  }

  //landingPage
  useEffect(() => {
    landingPageStatusUpdate();
  }, [landingchecked]);

  const landingPageStatusUpdate = async () => {
    //alert(landingchecked);
    let inputValue = (landingchecked) ? '1' : '0';

    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updLandingPageChk", {
      val: inputValue,
      survey_id: survey_id,
      language_code: language_code,

    }).then((response) => {
      // 
      if (response.status == 200) {
        // // alert("successfull!");
      } else {
        alert("Try Again, Error");
      }
    });
  }

  //Thankyou 
  useEffect(() => {
    thankyouPageStatusUpdate();
  }, [thankyouchecked]);

  const thankyouPageStatusUpdate = async () => {
    // alert(thankyouchecked);
    let inputValue = (thankyouchecked) ? '1' : '0';

    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updThankYouPageChk", {
      val: inputValue,
      survey_id: survey_id,
      language_code: language_code,

    }).then((response) => {

      if (response.status == 200) {
        // alert("successfull!");
      } else {
        alert("Try Again, Error");
      }
    });
  }
  //LeadGen 
  useEffect(() => {
    leadGenPageStatusUpdate();
  }, [leadGenchecked]);

  const leadGenPageStatusUpdate = async () => {
    // alert(leadGenchecked);
    let inputValue = (leadGenchecked) ? '1' : '0';

    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updLeadGenChk", {
      val: inputValue,
      survey_id: survey_id,
      language_code: language_code,

    }).then((response) => {

      if (response.status == 200) {
        // alert("successfull!");
      } else {
        alert("Try Again, Error");
      }
    });
  }
  //  Sections
  useEffect(() => {
    sectionPageStatusUpdate();
  }, [sectionchecked]);

  const sectionPageStatusUpdate = async () => {
    // alert(sectionchecked);
    let inputValue = (sectionchecked) ? '1' : '0';

    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updSectionChk", {
      val: inputValue,
      survey_id: survey_id,
      language_code: language_code,

    }).then((response) => {

      if (response.status == 200) {
        // alert("successfull!");
      } else {
        alert("Try Again, Error");
      }
    });
  }
  //  Scoring 
  useEffect(() => {
    scoringPageStatusUpdate();
  }, [scoringchecked]);

  const scoringPageStatusUpdate = async () => {
    // alert(scoringchecked);
    let inputValue = (scoringchecked) ? '1' : '0';

    Axios.patch(process.env.REACT_APP_NODE_API_URL + "/survey/updScoreChk", {
      val: inputValue,
      survey_id: survey_id,
      language_code: language_code,

    }).then((response) => {

      if (response.status == 200) {
        // alert("successfull!");
      } else {
        alert("Try Again, Error");
      }
    });
  }

  //TODO need to make middleware
  const checkToken = async (token_id) => {
    fetch(process.env.REACT_APP_NODE_API_URL + `/auth/getTokenData?token_id=` + token_id)
      .then(res => res.json())
      .then(
        (result) => {
          console.log(result);
        },
        (error) => {
          console.log(error);
          alert("5 token not verified, or expired, Login Again");
          window.location = '/';
        }
      )

  }

  function handleClick(childNo) {
    setstyling({ status: false, style: "applyBgColor" });
  }

  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };


  return (
    <>
      <div id="content" className="flex-grow-1 dashboard-page-outer">
        {/* <SubHeader title={survey_title} /> */}
        <div className="survey-main-container">
          <div className="page-heading d-flex align-items-center justify-content-between">
            <div className='head-lef'>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/survey/list">{t('survey.title')}</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name ?? 'Draft survey'}</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    <strong>{t('survey.question.title')}</strong>
                  </li>
                </ol>
              </nav>
            </div>

          </div>
          <div className="survey-container">
            <div className="accordion surveyAccordian" id="surveyaccordian">
              {/* Questionaire Title */}
              <div className="content-wrapper">

                {/* View Version */}
                {/* Edit Version */}
                {!surveyHeaderEditMode ?
                  <div className="d-flex align-items-start">
                    <div className="flex-grow-1 pe-2">
                      <div className="qna-section-top">
                        <div className="mb-2">
                          <div className="survey-title">{values.surveyTitle}</div>

                        </div>
                        <div className="mb-2">
                          <div className="editablesubtitle">{values.surveyDesc}</div>
                        </div>
                      </div>
                    </div>
                    {window.modulePermissions.M11.edit == 1 && (<div className="btn-wrap">
                      <button className='btn btn-edit' title='Edit Survey' onClick={() => setSurveyHeaderEditMode(true)}> <Svg name="edit" /> </button>
                    </div>)}
                  </div>
                  :
                  <div className="d-flex align-items-start">
                    <div className="flex-grow-1 pe-2">
                      <div className="qna-section-top">
                        <div className="mb-2 position-relative">
                          <EditText
                            className='survey-title'
                            inputClassName='survey-title input-class'
                            placeholder='Survey Title'
                            name="surveyTitle"
                            value={values.surveyTitle}
                            onChange={handleChange}
                            onBlur={() => setFieldTouched('surveyTitle', true)}
                            onSave={(data) => handleSaveTitle(data, touched.surveyTitle && errors.surveyTitle)}
                          />
                          {touched.surveyTitle && errors.surveyTitle && <div className='validation-msg'>{errors.surveyTitle}</div>}
                        </div>
                        <div className="mb-2 position-relative">
                          <EditTextarea
                            className="editablesubtitle"
                            inputClassName='editablesubtitle'
                            rows={3}
                            placeholder={t('survey.question.description')}
                            name="surveyDesc"
                            value={values.surveyDesc}
                            onChange={handleChange}
                            onBlur={() => setFieldTouched('surveyDesc', true)}
                            onSave={(data) => handleSaveDescription(data, touched.surveyDesc && errors.surveyDesc)}
                          />
                          {touched.surveyDesc && errors.surveyDesc && <div className='validation-msg'>{errors.surveyDesc}</div>}
                        </div>
                      </div>
                    </div>
                    <div className="btn-wrap">
                      <button className='btn btn-dlt'  onClick={() => setSurveyHeaderEditMode(false)}> <Svg name="save-icon" /> </button>
                    </div>
                  </div>}

                <div className="info-text">
                  {/* <i>2 Sections, 8 Questions</i> */}
                  <i>{surveySectionData?.length ?? 0} {t('survey.question.sections')} , {surveyQuestionData?.length ?? 0}{t('survey.question.questions')}</i>
                  {/* {(survey_setting != 0) ?
                    <i>{survey_setting?.sections?.numberOfSections} Sections, {survey_setting.numberOfQuestion} Questions </i>
                    : <i>{surveySectionData?.length ?? 0} Sections, {surveyQuestionData?.length ?? 0} Questions</i>} */}
                </div>
              </div>
              {/* Section Wrapper */}
              {
                surveySectionData?.map((section, index, sectionArr) => {
                  return (
                    <div className="section-wrapper-outer" key={index}>
                      <div className="section-data-wrapper">
                        <SectionHeader
                          sectionData={section}
                          sectionIndex={index}
                          language_code={language_code}
                          survey_id={survey_id}
                          totalSections={sectionArr?.length ?? 0}
                          nextSection={sectionArr[index + 1] ? sectionArr[index + 1] : sectionArr[index - 1]}
                          questionCount={sectionWiseQuestion && (sectionWiseQuestion[section.su_section_id]?.length ?? 0)}
                        />
                        <SectionContent
                          language_code={language_code}
                          survey_id={survey_id}
                          questions={sectionWiseQuestion && sectionWiseQuestion[section.su_section_id]}
                        />
                      </div>

                      {window.modulePermissions.M11.add == 1 && (<div className="button-wrap d-flex">
                        <Button className={"formssurveybutton me-3"}
                          type="default"
                          view="filled"
                          color="primary"
                          text={t('survey.question.addq')}
                          onClick={() => handleAddQuestion(section?.su_section_id)}
                        />
                        <Button className={"formssurveybutton btn-bordered"}
                          type="default"
                          view="outlined"
                          color="default"
                          text={t('survey.question.adds')}
                          onClick={() => handleAddSection(index)}
                        />
                      </div>)}
                    </div>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>

      <div className="customvar-modal modal custom-modal fade edit-pop-modal" id="editField" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer " + style.container}>
                <div className={"formvawrapper modal-edit " + style.wrapper}>
                  <Card view="raised" className={"formstyle p-4 " + style.card} >
                    <div className="edit-field-wrap p-0 mb-4">
                      <h5>Edit choice 1</h5>
                      <EditorMultipleChoice />
                    </div>
                    <div className="button-wrap d-flex justify-content-end">
                      <button type="button" className="btn btn-bordered" data-bs-dismiss="modal">Cancel</button>
                      <button type="button" className="btn btn-primary ms-3">Save</button>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="customvar-modal modal custom-modal fade moveSection-modal" id="moveSection" tabIndex={-1} aria-labelledby="moveSectionLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer " + style.container}>
                <div className={"formvawrapper modal-edit " + style.wrapper}>
                  <Card view="raised" className={"formstyle p-0 " + style.card} >
                    <div className="edit-field-wrap p-0">
                      <div className="heading p-4">
                        <h5 className="mb-0">{t('survey.question.recorders')}</h5>
                      </div>
                      <div>
                        <DragDropContext onDragEnd={onDragEnd}>
                          <Droppable droppableId="sectionList">
                            {provided => (
                              <div className="reorder-section-wrapper" ref={provided.innerRef} {...provided.droppableProps}>

                                {modalSortableSurveySectionData?.map((section, index, arr) => {
                                  const sectionName = section.su_section_name && JSON.parse(section.su_section_name)[language_code]
                                  return (
                                    <Draggable draggableId={`sectionList${index}`} index={index} key={index}>
                                      {provided => (
                                        <div
                                          className='text-wrap d-flex align-items-center'
                                          key={index}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                        >
                                          <div className="icon-wrap">
                                            <Svg name="draggable" />
                                          </div>
                                          <div className="flex-grow-1 text-inner">
                                            <div className="sec-name">{sectionName}</div>
                                            <div className="sec-count">{t('survey.question.sections')} {section.su_order_no ?? 'NA'}/{arr?.length}</div>
                                          </div>
                                        </div>
                                      )}
                                    </Draggable>
                                  )
                                })}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </div>
                    </div>
                    <div className="button-wrap d-flex justify-content-end p-4">
                      <button type="button" className="btn btn-bordered" data-bs-dismiss="modal" onClick={resetModalSectionData}>{t('survey.customVariable.cancel')}</button>
                      {window.modulePermissions.M11.edit == 1 && (<button type="button" className="btn btn-primary ms-3" data-bs-dismiss="modal" onClick={() => saveNewSortedSection(modalSortableSurveySectionData)}>{t('settings.team.create_team.save')}</button>)}
                    </div>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
